import { render } from "./uploadArtwork.vue?vue&type=template&id=49a3b504&scoped=true"
import script from "./uploadArtwork.vue?vue&type=script&lang=js"
export * from "./uploadArtwork.vue?vue&type=script&lang=js"

import "./uploadArtwork.vue?vue&type=style&index=0&id=49a3b504&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a3b504"]])

export default __exports__